import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DEFAULT_LIBRARY_VIEW, LibraryPage } from '../../pages/library';
import { useSession } from '../../entities/session';
import {
  listFiltersToSearch,
  parseListFilters,
  type IListFilters,
} from '../../features/list-filters';

const text = (value: unknown) => (typeof value === 'string' && value !== '' ? value : undefined);

export const Route = createFileRoute('/_shell/library/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function LibraryRoute() {
    const navigate = useNavigate();
    const search = Route.useSearch();
    const filters = parseListFilters(search, DEFAULT_LIBRARY_VIEW);
    const folder = text(search.folder);
    const q = text(search.q);
    const session = useSession();

    const go = (next: { filters?: IListFilters; folder?: string; q?: string }) =>
      void navigate({
        to: '/library',
        search: {
          ...listFiltersToSearch(next.filters ?? filters),
          ...(next.folder ? { folder: next.folder } : {}),
          ...(next.q ? { q: next.q } : {}),
        },
      });

    return (
      <LibraryPage
        filters={filters}
        folder={folder}
        q={q}
        timeZone={session.data?.preferences.timezone}
        onFilters={(next) => go({ filters: next, folder, q })}
        onFolder={(next) => go({ folder: next ?? undefined })}
        onSearch={(next) => go({ folder, q: next })}
        onOpen={(item) => void navigate({ to: '/library/$itemId', params: { itemId: item.id } })}
      />
    );
  },
});
